import {ValueObject} from '@s-ui/domain'

import {NumberSharedValueObject} from '../../shared/ValueObjects/NumberSharedValueObject.js'

export class PriceSpecificationValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static empty() {
    return new PriceSpecificationValueObject({
      value: NumberSharedValueObject.create({value: 0})
    })
  }

  static create({price}) {
    if (!price) return PriceSpecificationValueObject.empty()

    return new PriceSpecificationValueObject({
      value: NumberSharedValueObject.create({value: price})
    })
  }

  get value() {
    return this.#value.value
  }

  isEmpty() {
    return this.#value.isEmpty || this.#value.value === 0
  }
}
